export const BREAKPOINTS = [25, 50, 75];
